export default "__VITE_ASSET__CncgKYsQ__"